import { useLanguage } from "@/lib/i18n";
import { getLocalizedFAQ } from "@/lib/faqContent";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function FAQSection() {
  const { t, language } = useLanguage();
  const faqItems = getLocalizedFAQ(language);

  return (
    <section id="faq" className="py-14 md:py-16 bg-section-gradient" aria-label="FAQ">
      <div className="container max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-5">
            {t('faq.sectionTitle')}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqItems.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`faq-${idx}`}
              className="bg-white/80 backdrop-blur-sm rounded-2xl border border-white/50 shadow-soft px-6 data-[state=open]:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left font-semibold text-sm md:text-base py-5 hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pb-5 faq-answer">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
